import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/mark.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';
import { MarkElem } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('mark', styles);
/** @since 12.0.0 */
function Mark(_a) {
  var {
      Elem = 'mark',
      extraClasses,
      children
    } = _a,
    rest = __rest(_a, ["Elem", "extraClasses", "children"]);
  return /*#__PURE__*/React.createElement(Elem, Object.assign({
    className: bem.b({}, extraClasses)
  }, rest), children);
}
Mark.displayName = 'Mark';
Mark.propTypes = {
  Elem: PropTypes.oneOf(MarkElem),
  children: PropTypes.node.isRequired,
  extraClasses: PropTypes.string
};
var Mark$1 = Injecss(Mark, styles);

export { Mark, Mark$1 as default };
